import {LitElement, html, CSSResult, unsafeCSS} from 'lit';
import {customElement, property} from "lit/decorators.js";
import styles from './product-section.scss';
import {Article, Messages} from "../../../@types/online-reservation.js";
import {consume} from "@lit/context";
import {i18nContext} from "../i18nContext.js";

@customElement('product-section')
export class ProductSection extends LitElement {

  @property({type: Object, reflect: false})
  private readonly article!: Article;

  @consume({context: i18nContext})
  private readonly messages!: Messages;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  render() {
    return html`
      <div class="ents-product-section">
        <section class="ents-product-section__image">
          <img src=${this.article.image.src} alt=${this.article.image.alt} data-test-image />
        </section>
        <header class="ents-product-section__header">
          <span class="ents-product-section__header--brand ents-copy-small-bold" data-test-brand>${this.article.brand}</span>
          <p class="ents-product-section__header--name ents-copy-small" title="${this.article.name}" data-test-name>${this.article.name}</p>
          ${this.article.color ? html`<p class="ents-product-section__header--description ents-copy-small"
          title="${this.messages['color']} ${this.article.color}" data-test-description>${this.messages['color']} ${this.article.color}</p>` : ''}
          <div class="bdk-badge-price ents-product-section__price" size="small" ?sale=${this.article.price.priceReduced} data-test-price>
            ${this.article.price.value}
          </div>
        </header>
      </div>
    `;
  }
}
